import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { defineStore } from 'pinia';

import { SCREEN_BREAKPOINTS } from '../../models';
import type { ScreenSizeType } from '../../models';

import { getScreenSizeType } from './screenSizeStore.helper';

export const useScreenSizeStore = defineStore('ScreenSizeStore', () => {
  const { width } = useWindowSize();

  // Getters
  const screenSizeType = computed(() => getScreenSizeType(width.value));

  // Getters - functions
  function isWiderOrEqualThan(screenSizeType: ScreenSizeType): boolean {
    return width.value >= SCREEN_BREAKPOINTS[screenSizeType];
  }

  function isNarrowerThan(screenSizeType: ScreenSizeType): boolean {
    return width.value < SCREEN_BREAKPOINTS[screenSizeType];
  }

  return {
    // Getters
    screenSizeType,

    // Getters - functions
    isNarrowerThan,
    isWiderOrEqualThan,
  };
});
